import React, { useContext } from "react";
import { getDwk } from "bodycodi/cmap/app/js/common";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

type TimePickerProp = {
  typeName: "시작" | "종료";
  chooseDate: { year: number; month: number; date: number };
  currentHours: string;
  currentMinutes: string;
  handleChangeTime: any;
};

export const getPickerTime = () => {
  const now = new Date();
  const currentHours = now.getHours();
  const currentMinutes = now.getMinutes();

  let startHours = currentHours;
  let startMinutes = 0;
  let endHours = 0;
  let endMinutes = 0;

  if (currentMinutes % 10 === 0 || currentMinutes % 10 === 5) {
    startMinutes = currentMinutes;
  } else if (currentMinutes % 10 < 5) {
    startMinutes = currentMinutes - (currentMinutes % 10) + 5;
  } else {
    if (currentMinutes - (currentMinutes % 10) + 10 === 60) {
      startHours = currentHours + 1;
      startMinutes = 0;
    } else {
      startMinutes = currentMinutes - (currentMinutes % 10) + 10;
    }
  }
  endHours = startHours + 1;
  endMinutes = startMinutes;

  if (startHours === 23) {
    return {
      startHours,
      startMinutes,
      endHours: 23,
      endMinutes: 55,
    };
  }
  if (startHours === 24) {
    return {
      startHours: 23,
      startMinutes: 55,
      endHours: 23,
      endMinutes: 55,
    };
  }
  return {
    startHours,
    startMinutes,
    endHours,
    endMinutes,
  };
};

const TimePicker = ({
  typeName,
  chooseDate,
  currentHours,
  currentMinutes,
  handleChangeTime,
}: TimePickerProp) => {
  const chooseDateFormat = `${chooseDate.month}. ${chooseDate.date}. ${getDwk(
    new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay()
  )}`;

  return (
    <div>
      <div className="picker-wrapper">
        <div>
          <span className="type">{typeName}</span>
          <span>{chooseDateFormat}</span>
        </div>
        <div className="time-wrapper" onClick={() => handleChangeTime(typeName)}>
          {currentHours} : {currentMinutes}
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
